import { render, staticRenderFns } from "./RiderHistoryAssignments.vue?vue&type=template&id=5870bd1c&"
import script from "./RiderHistoryAssignments.vue?vue&type=script&lang=js&"
export * from "./RiderHistoryAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports